import { BaseFile, BaseFolder, BaseNode, NodeType } from './base';

export const isTemplate = (node: BaseNode): node is TemplateNode =>
  node.type === NodeType.Template;

export type TemplateTreeNode = TemplateNode | TemplateFolderNode;

export type BaseTemplateTreeNode = {} & BaseNode;

export type TemplateNode = {
  type: NodeType.Template;
  onTemplateEdit?: (
    templateItemId: string,
    editedProperty: 'name',
  ) => Promise<void>;
  activity: TemplateActivity | null;
} & BaseFile &
  BaseTemplateTreeNode;

export type TemplateFolderNode = {
  onFolderEdit: (
    folderId: string,
    editedName: string,
    editedProperty: 'name',
  ) => Promise<void>;
} & BaseFolder<BaseTemplateTreeNode> &
  BaseTemplateTreeNode;

export type TemplateActivity = {
  date: Date;
  user: string;
  action: 'import' | 'update';
};
